import React, { Fragment, useCallback, useEffect, useState } from "react";
import PageBannerComponent from "../Components/Common/PageBannerComponent";
import { Link, useParams } from "react-router-dom";
import { useAddFavoriteCompanyMutation } from "../Store/api/DataApi";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../Store";
import {
  error,
  noPermissionAlert,
  success,
  waringMessage,
} from "../Services/CommonService";
import { useGetCompanyDetailQuery } from "../Store/api/CommonApi";
import JobPostComponent from "../Components/Jobs/JobPostComponent";
import RelatedJobComponent from "../Components/Jobs/RelatedJobComponent";
import { actionLogout } from "../Store/slices/AuthSlice";

export default function CompanyDetail() {
  const { isAuth, profile } = useSelector((state: RootState) => state.auth);
  const [addFavoriteCompany] = useAddFavoriteCompanyMutation();
  const [relatedJob, setRelatedJob] = useState([]);

  const { id } = useParams();
  const { data, refetch } = useGetCompanyDetailQuery(id);
  const dispatch = useDispatch();

  useEffect(() => {
    window.$(".nav-tabs").tab();
  }, []);

  useEffect(() => {
    if (data?.data) {
      setRelatedJob(data?.relatedJobs);

      setTimeout(() => {
        window.$(".active-relatedjob-carusel").owlCarousel({
          items: 1,
          autoplay: true,
          loop: data?.relatedJobs.length > 1 ? true : false,
          margin: 30,
          dots: true,
        });
      }, 500);
    }
  }, [data]);

  const handleAddFavorite = useCallback(
    (id) => {
      if (isAuth && profile?.lgbt_status === 1) {
        addFavoriteCompany(id)
          .then((res) => {
            console.log(res.error?.data?.error);
            if (res.error?.data?.error !== undefined) {
              error(res.error?.data?.error);
            } else if (res.data?.error !== undefined) {
              error(res.data?.error);
              if (res.data?.error === "Invalid token!") {
                dispatch(actionLogout());
              }
            } else {
              refetch();
              success(res?.data?.message);
            }
          })
          .catch((err) => {
            console.log(err);

            error(err?.error?.data?.error);
          });
      } else if (isAuth && profile?.lgbt_status === 0) {
        noPermissionAlert();
      } else {
        waringMessage("Follow Company");
      }
    },
    [addFavoriteCompany, isAuth, profile, dispatch, refetch]
  );

  return (
    <Fragment>
      <PageBannerComponent
        //title={data?.data?.company_name}
        title={""}
        image={
          data?.data?.banner_image !== undefined &&
          data?.data?.banner_image !== ""
            ? data?.path + String(data?.data?.banner_image)
            : ""
        }
      />
      {/* start Company logo & social media handle section */}
      <section className="detail-desc advance-detail-pr">
        <div className="container white-shadow">
          <div className="row">
            <div className="detail-pic text-center">
              <div className="company_logo">
                {data?.data.company_logo ? (
                  <img
                    src={
                      String(data?.path) +
                      String(encodeURI(data?.data.company_logo))
                    }
                    className="img-fluid"
                    alt={data?.data.company_name}
                  />
                ) : (
                  //  <img
                  //    src={require("../Assets/img/no-image.png")}
                  //    className="img-fluid"
                  //    alt={data?.data.company_name}
                  //  />
                  <i
                    className="fa fa-image fa-5x"
                    title={data?.data.company_name}
                  ></i>
                )}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="detail pannel-footer">
              <div className="col-md-12 col-sm-12 text-center">
                <h4 className="mb-2">{data?.followers ?? 0} Followers</h4>
                <ul className="detail-footer-social">
                  {data?.data.website_link && (
                    <li>
                      <Link to={data?.data.website_link} target="_blank">
                        <i className="fa fa-link" />
                      </Link>
                    </li>
                  )}
                  {data?.data.linkedin_link && (
                    <li>
                      <Link to={data?.data.linkedin_link} target="_blank">
                        <i className="fa fa-linkedin" />
                      </Link>
                    </li>
                  )}
                  {data?.data.instagram_link && (
                    <li>
                      <Link to={data?.data.instagram_link} target="_blank">
                        <i className="fa fa-instagram" />
                      </Link>
                    </li>
                  )}
                  {data?.data.facebook_link && (
                    <li>
                      <Link to={data?.data.facebook_link} target="_blank">
                        <i className="fa fa-facebook" />
                      </Link>
                    </li>
                  )}
                  {data?.data.twitter_link && (
                    <li>
                      <Link to={data?.data.twitter_link} target="_blank">
                        <i className="fa fa-twitter" />
                      </Link>
                    </li>
                  )}
                  {data?.data.youTube_link && (
                    <li>
                      <Link to={data?.data.youTube_link} target="_blank">
                        <i className="fa fa-youtube" />
                      </Link>
                    </li>
                  )}
                  <li onClick={() => handleAddFavorite(data?.data?.id)}>
                    <a className="btn btn-info">+ Follow This Page</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* End Area */}
      {/* Start post Area */}
      <section className="post-area section-gap">
        <div className="container">
          <div className="row justify-content-center d-flex">
            <div className="col-lg-8 post-list">
              <div className="tab tool-tab" role="tabpanel">
                {/* Nav tabs */}
                <ul className="nav nav-tabs" role="tablist">
                  <li role="presentation">
                    <a
                      href="#Section1"
                      role="tab"
                      data-toggle="tab"
                      className="active"
                    >
                      <i className="fa fa-envelope-o" />
                      Overview
                    </a>
                  </li>
                  <li role="presentation">
                    <a href="#Section2" role="tab" data-toggle="tab">
                      <i className="fa fa-cube" />
                      Why Join Us
                    </a>
                  </li>
                  <li role="presentation">
                    <a href="#Section3" role="tab" data-toggle="tab">
                      <i className="fa fa-briefcase" />
                      Jobs
                    </a>
                  </li>
                  {/* <li role="presentation">
                    <a href="#Section4" role="tab" data-toggle="tab">
                      <i className="fa fa-trophy" />
                      Awards
                    </a>
                  </li> */}
                </ul>
                {/* Tab panes */}
                <div className="tab-content tabs" id="home">
                  <div
                    role="tabpanel"
                    className="tab-pane active"
                    id="Section1"
                  >
                    <h3 className="pb-15">About {data?.data?.company_name}</h3>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: data?.data?.about_company,
                      }}
                    ></p>
                  </div>
                  <div role="tabpanel" className="tab-pane fade" id="Section2">
                    <h3 className="pb-15">Message by MD/ CHRO/ CDO</h3>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: data?.data?.why_join_us,
                      }}
                    ></p>
                  </div>
                  <div role="tabpanel" className="tab-pane fade" id="Section3">
                    {data?.jobs.length > 0 &&
                      data?.jobs.map((job, i) => (
                        <JobPostComponent
                          item={job}
                          path={data?.path}
                          key={i}
                        />
                      ))}

                    {/* <div className="single-post">
                      <div className="details">
                        <div className="title d-flex flex-row justify-content-between">
                          <div className="titles">
                            <Link to="/job-detail">
                              <h4>Search Engine Optimaization Executive</h4>
                            </Link>
                            <h6>Primeiq Research</h6>
                          </div>
                          <ul className="btns">
                            <li>
                              <Link className="signin">
                                <span className="lnr lnr-heart" />
                              </Link>
                            </li>
                            <li>
                              <Link to="/job-detail">Apply</Link>
                            </li>
                          </ul>
                        </div>
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipisicing
                          elit, sed do eiusmod temporinc ididunt ut dolore magna
                          aliqua.
                        </p>
                        <h5>Job Nature: Full time</h5>
                        <p className="address">
                          <span className="lnr lnr-map" /> 56/8, Panthapath
                          Dhanmondi Dhaka
                        </p>
                        <p className="address">
                          <span className="lnr lnr-database" /> 15k - 25k
                        </p>
                      </div>
                    </div> */}
                  </div>
                  <div role="tabpanel" className="tab-pane fade" id="Section4">
                    <div className="rb-container">
                      <ul className="rb">
                        <li className="rb-item" ng-repeat="itembx">
                          <div className="timestamp">
                            3rd May 2020 | 7:00 PM
                          </div>
                          <div className="item-title">
                            Chris Serrano posted a photo on your wall.
                          </div>
                        </li>
                        <li className="rb-item" ng-repeat="itembx">
                          <div className="timestamp">
                            19th May 2020 | 7:00 PM
                          </div>
                          <div className="item-title">
                            Mia Redwood commented on your last post.
                          </div>
                        </li>
                        <li className="rb-item" ng-repeat="itembx">
                          <div className="timestamp">
                            17st June 2020 | 7:00 PM
                          </div>
                          <div className="item-title">
                            Lucas McAlister just send you a message.
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 sidebar">
              {relatedJob.length > 0 && (
                <div className="single-slidebar">
                  <h4>Related Jobs</h4>
                  <div className="active-relatedjob-carusel">
                    {relatedJob.map((job, i) => (
                      <RelatedJobComponent
                        item={job}
                        path={data?.path}
                        key={i}
                      />
                    ))}
                    {/* <div className="single-rated">
                    <img className="img-fluid" src="img/r1.jpg" alt="" />
                    <a href="single.html">
                      <h4>Creative Art Designer</h4>
                    </a>
                    <h6>Premium Labels Limited</h6>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit,
                      sed do eiusmod temporinc ididunt ut dolore magna aliqua.
                    </p>
                    <h5>Job Nature: Full time</h5>
                    <p className="address">
                      <span className="lnr lnr-map" /> 56/8, Panthapath
                      Dhanmondi Dhaka
                    </p>
                    <p className="address">
                      <span className="lnr lnr-database" /> 15k - 25k
                    </p>
                    <Link to="/job-detail" className="btns text-uppercase">
                      Apply job
                    </Link>
                  </div>
                  <div className="single-rated">
                    <img className="img-fluid" src="img/r1.jpg" alt="" />
                    <a href="single.html">
                      <h4>Creative Art Designer</h4>
                    </a>
                    <h6>Premium Labels Limited</h6>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit,
                      sed do eiusmod temporinc ididunt ut dolore magna aliqua.
                    </p>
                    <h5>Job Nature: Full time</h5>
                    <p className="address">
                      <span className="lnr lnr-map" /> 56/8, Panthapath
                      Dhanmondi Dhaka
                    </p>
                    <p className="address">
                      <span className="lnr lnr-database" /> 15k - 25k
                    </p>
                    <Link href="/job-detail" className="btns text-uppercase">
                      Apply job
                    </Link>
                  </div>
                  <div className="single-rated">
                    <img className="img-fluid" src="img/r1.jpg" alt="" />
                    <a href="single.html">
                      <h4>Creative Art Designer</h4>
                    </a>
                    <h6>Premium Labels Limited</h6>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit,
                      sed do eiusmod temporinc ididunt ut dolore magna aliqua.
                    </p>
                    <h5>Job Nature: Full time</h5>
                    <p className="address">
                      <span className="lnr lnr-map" /> 56/8, Panthapath
                      Dhanmondi Dhaka
                    </p>
                    <p className="address">
                      <span className="lnr lnr-database" /> 15k - 25k
                    </p>
                    <Link to="/job-detail" className="btns text-uppercase">
                      Apply job
                    </Link>
                  </div> */}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
      {/* End post Area */}
    </Fragment>
  );
}
